"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var ButtonContext = /*#__PURE__*/_react["default"].createContext({
  href: null,
  onClick: null,
  tipOnOpen: null
});
var _default = exports["default"] = ButtonContext;